import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../store";
import "./Contact.css";
import { User } from "../Profile";
import { toast } from "react-toastify";
import SkillsBox from "./SkillsBox";

type ContactProps = {
  handleClick: () => void;
};

export const Contact: React.FC<ContactProps> = ({ handleClick }) => {
  const dispatch = useDispatch();
  const user = useSelector((state: AppState) => state.user); // get the current user object from the Redux store
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [phone, setPhone] = useState(user.phone);
  const [linkedin, setLinkedin] = useState(user.linkedin);
  const [failedSubmit, setFailedSubmit] = useState(false);
  const [skills, setSkills] = useState<string[]>(user.skills);

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const updateUserData = () => {
    if (name.length === 0) {
      toast.error("Name field is required.");
      setFailedSubmit(true);
      return;
    }

    if (email.length === 0) {
      toast.error("Email field is required.");
      setFailedSubmit(true);
      return;
    }

    const regexp = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    if (!regexp.test(email)) {
      toast.error("Entered email invalid.");
      setFailedSubmit(true);
      return;
    }

    const updatedUser: User = {
      ...user, // create a new object with all existing properties of the user object
      name: name,
      email: email,
      phone: phone,
      linkedin: linkedin,
      skills: skills,
    };
    dispatch({
      type: "UPDATE_STATE",
      payload: updatedUser,
    });

    handleClick();
  };

  const handleNameInput = (event: React.FormEvent<HTMLTextAreaElement>) => {
    setName(event.currentTarget.value);
  };

  const handleEmailInput = (event: React.FormEvent<HTMLTextAreaElement>) => {
    setEmail(event.currentTarget.value);
  };

  const handlePhoneInput = (event: React.FormEvent<HTMLInputElement>) => {
    const regex = /^[0-9+()\s-]*$/;

    if (regex.test(event.currentTarget.value)) {
      setPhone(event.currentTarget.value);
    }
  };

  const handleLinkedinInput = (event: React.FormEvent<HTMLTextAreaElement>) => {
    setLinkedin(event.currentTarget.value);
  };

  return (
    <div>
      <p className="text-light mb-10 ml-12 text-4xl font-bold md:ml-0">
        Basic Info
      </p>

      <div className="mx-auto flex w-4/5 flex-col md:w-full md:flex-row">
        <div className="inline-block w-full pr-2 md:w-2/5 md:pr-0">
          <p className="text-orange pl-3 text-3xl font-bold">
            FULL NAME <span className="text-red-500">*</span>
          </p>
          <textarea
            value={name}
            onInput={handleNameInput}
            className={`answer-box mt-3 w-full p-5 text-2xl ${
              failedSubmit ? "border-2 border-red-600" : ""
            }`}
            ref={textareaRef}
            placeholder="Alex Smith"
          />
        </div>
        <div className="ml-auto inline-block w-full md:w-2/5 md:pl-0 ">
          <p className="text-blue pl-3 text-3xl font-bold">
            EMAIL <span className="text-red-500">*</span>
          </p>
          <textarea
            value={email}
            onInput={handleEmailInput}
            className={`answer-box mt-3 w-full p-5 text-2xl ${
              failedSubmit ? "border-2 border-red-600" : ""
            }`}
            ref={textareaRef}
            placeholder="alexsmith@myemail.com"
          />
        </div>
      </div>
      <div className="mx-auto mt-10 flex w-4/5 flex-col md:w-full md:flex-row">
        <div className="inline-block w-full md:w-2/5 md:pr-0">
          <p className="text-blue text-3xl font-bold">PHONE</p>
          <input
            value={phone}
            onChange={handlePhoneInput}
            className="answer-box mt-3 h-24 w-full p-5 text-2xl"
            placeholder="(555) 555-5555"
            inputMode="tel"
            pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
            required
          />
        </div>
        <div className="ml-auto inline-block w-full md:w-2/5 md:pl-0">
          <p className="text-orange text-3xl font-bold">LINKEDIN</p>
          <textarea
            value={linkedin}
            onInput={handleLinkedinInput}
            className="answer-box mt-3 w-full p-5 text-2xl"
            ref={textareaRef}
            placeholder="linkedin.com/johndoe"
          />
        </div>
      </div>
      <div className="mx-auto w-4/5 pt-3 md:w-full">
        <p className="text-light mb-10 text-2xl font-bold lg:text-3xl xl:text-4xl">
          <span className="text-blue">Skills</span> and{" "}
          <span className="text-orange">Technologies</span>
        </p>
        <SkillsBox skills={skills} handleSkills={setSkills} />
      </div>
      <button
        className="login-button ml-12 mt-5 px-10 py-2 text-lg font-bold md:ml-0 md:py-4 md:text-xl lg:px-16 lg:text-3xl"
        onClick={updateUserData}
      >
        Next
      </button>
    </div>
  );
};
